module.exports = __webpack_public_path__ + "media/images/shared/arrow-grey-right-55839eee1482941abc8c7106555d87ec.png";